import {Component,Inject,Input} from 'ng-metadata/core';
import {PrimoResponse} from '../../../../../infra/dataStructures/PrimoResponses/doc.interfcae';


@Component({
	selector: 'prm-requests-services-ovl',
	templateUrl: 'components/search/fullView/getit/opac/request/request-services-ovl.html',
})


export class PrmRequestsServicesOvl{
	@Input() public item: PrimoResponse.IDoc;


	constructor(@Inject('$window') private $window: ng.IWindowService,
				@Inject('availabilityLineIcons') public availabilityLineIcons) {
	}

	public hasLocations(){
		return this.item.delivery.holding.length > 0;
	}

	get requestLink() {
		try {
			let getitTab = this.item.delivery.GetIt1.filter(
				getit => getit.links[0].displayText === 'linktoholdings'
			)[0];
			return getitTab.links[0].link;
		} catch( err ){
			return null;
		}

	}
}




// WEBPACK FOOTER //
// ./src/main/webapp/components/search/fullView/getit/opac/request/requestsServicesOvl.directive.ts